import { render, staticRenderFns } from "./AdminDocuments.vue?vue&type=template&id=b9035482&scoped=true&"
import script from "./AdminDocuments.vue?vue&type=script&lang=js&"
export * from "./AdminDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9035482",
  null
  
)

export default component.exports